<div class="d-flex flex-column justify-content-center align-items-center">
  <div class="text-center">
    <h1 class="text-dark-85 font-weight-bold">404</h1>
    <h3 class="text-dark-65 font-weight-bold">Page Not Found</h3>
    <p class="text-dark-50 font-weight-bold mt-12">We're sorry, the page you requested could not be found.</p>
    <div class="pb-lg-0 pb-20">
      <button type="button" class="btn btn-pill btn-primary px-15 mt-2" (click)="back()">
        Back to Homepage
      </button>
    </div>
  </div>
</div>
